export default __webpack_public_path__ + "images/SN.b65ceed.png";